const colors = {
  red: '#ff5f66',
  green: '#1abe8a',
  blur: '#4398ff',
  yellow: '#ffa529',
  purple: '#6d2ef8'
}

export const HEADER_BG_GRADIENT = {
  '#6D2EF8': '#6D2EF8',
  '#007AFF': '#007AFF',
  '#2B9F50': '#2B9F50',
  '#FF2910': '#FF2910',
  '#150448': '#150448'
}

export const SVGREG = /^\/.+\.svg$/

export const TITLE = '铸剑'

export const SVGPATH = 'https://erphostjs.kye-erp.com/module-icon'

export const systemIconColors = {
  COO: colors.blur,
  CRM: colors.green,
  EC: colors.red,
  ECMS: colors.purple,
  FMS: colors.yellow,
  HOME: colors.purple,
  HRMS: colors.green,
  IAAMS: colors.green,
  IMS: colors.red,
  KTS: colors.yellow,
  KYETREE: colors.yellow,
  MAP: colors.purple,
  MCS: colors.blur,
  NET: colors.purple,
  OAMS: colors.green,
  OEM: colors.blur,
  PMS: colors.yellow,
  RBAC: colors.red,
  SYS: colors.purple,
  TDS: colors.green,
  TIC: colors.blur,
  TMS: colors.purple,
  URM: colors.blur,
  VMS: colors.purple
}



// WEBPACK FOOTER //
// ./src/layout/layout/conf.js